import { apiConfig } from "../../config";
// import * as crypto from "node:crypto";
const session_storage_key = "git_token_key";
const prefixUrl = "/api";
export class AuthService {
    apiService;
    // private cryptoKey: string = crypto.randomBytes(32).toString('base64');
    sessionCredentials;
    constructor(apiService) {
        this.apiService = apiService;
    }
    async initialize() {
        if (this.sessionCredentials) {
            return;
        }
        const axiosConfig = {
            method: "GET",
            url: `${apiConfig.host}/initialize`,
            headers: {
                'Content-Type': 'application/json',
            },
        };
        return this.apiService.requestFromConfig(axiosConfig).then(response => {
            this.sessionCredentials = response.data;
        });
    }
    clearPersistence() {
        this.sessionCredentials = undefined;
    }
    getSessionKey() {
        return this.sessionCredentials?.crypto_session_key;
    }
}
